// Utility functions for managing tokens and data in localStorage.

/**
 * Save access token to localStorage.
 */
export const saveAccessToken = async (token: string): Promise<void> => {
  try {
    localStorage.setItem("accessToken", token);
  } catch (e) {
    console.error("localStorage is not available.", e);
    throw new Error("localStorage is not available.");
  }
};

/**
 * Get access token from localStorage.
 */
export const getAccessToken = async (): Promise<string | null> => {
  try {
    return localStorage.getItem("accessToken");
  } catch (e) {
    console.error("localStorage is not available.", e);
    return null;
  }
};

/**
 * Remove access token from localStorage.
 */
export const removeAccessToken = async (): Promise<void> => {
  try {
    localStorage.removeItem("accessToken");
  } catch (e) {
    console.error("localStorage is not available.", e);
    throw new Error("localStorage is not available.");
  }
};

/**
 * Save refresh token to localStorage.
 */
export const saveRefreshToken = async (token: string): Promise<void> => {
  try {
    localStorage.setItem("refreshToken", token);
  } catch (e) {
    console.error("localStorage is not available.", e);
    throw new Error("localStorage is not available.");
  }
};

/**
 * Get refresh token from localStorage.
 */
export const getRefreshToken = async (): Promise<string | null> => {
  try {
    return localStorage.getItem("refreshToken");
  } catch (e) {
    console.error("localStorage is not available.", e);
    return null;
  }
};

/**
 * Remove refresh token from localStorage.
 */
export const removeRefreshToken = async (): Promise<void> => {
  try {
    localStorage.removeItem("refreshToken");
  } catch (e) {
    console.error("localStorage is not available.", e);
    throw new Error("localStorage is not available.");
  }
};

/**
 * Clear all auth tokens from localStorage.
 */
export const clearAllTokens = async (): Promise<void> => {
  try {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("expiryDate");
    localStorage.removeItem("tokenType");
  } catch (e) {
    console.error("localStorage is not available.", e);
    throw new Error("localStorage is not available.");
  }
};

/**
 * Save user data to localStorage.
 */
export const saveUserData = async (userData: any): Promise<void> => {
  try {
    localStorage.setItem("userData", JSON.stringify(userData));
  } catch (e) {
    console.error("localStorage is not available.", e);
    throw new Error("localStorage is not available.");
  }
};

/**
 * Get user data from localStorage.
 */
export const getUserData = async (): Promise<any | null> => {
  try {
    const userData = localStorage.getItem("userData");
    if (!userData) {
      return null;
    }
    return JSON.parse(userData);
  } catch (e) {
    console.error("Failed to get or parse user data from localStorage.", e);
    return null;
  }
};